export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M21 6H3v2h18V6ZM3 11h18v2H3v-2ZM3 16h12v2H3v-2Z\"/></svg>";